/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IGtmBodyData } from './gtm-body.data';
import { IGtmBodyProps } from './gtm-body.props.autogenerated';

export interface IGtmBodyViewProps extends IGtmBodyProps<IGtmBodyData> {}

/**
 *
 * GtmBody component
 * @extends {React.PureComponent<IGtmBodyProps<IGtmBodyData>>}
 */
class GtmBody extends React.PureComponent<IGtmBodyProps<IGtmBodyData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default GtmBody;
